import { combineReducers } from 'redux';
import AdminReducer from './reducer';
const rootReducer = combineReducers({
  AdminReducer:AdminReducer
});

export default rootReducer;
